import PropTypes from 'prop-types'
import React from 'react'

import * as Icons from 'components/Utils/Icons'

const Checkbox = props => {
  const { id, label, checked, size, ...inputProps } = props

  return (
    <div className="pointer shade-10-on-hover shade-20 flexbox flexbox-align-center">
      <div
        className="flexbox flexbox-align-center shade-30-blue"
        style={{ position: 'relative' }}
      >
        {checked ? (
          <Icons.CheckboxIcon size={size} />
        ) : (
          <Icons.CheckboxEmptyIcon size={size} />
        )}
        <input
          id={id}
          type="checkbox"
          checked={checked}
          {...inputProps}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            opacity: 0,
            cursor: 'pointer',
          }}
        />
      </div>

      <label htmlFor={id} className="margin-left-small pointer">
        {label}
      </label>
    </div>
  )
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
}

export default Checkbox
